import React from "react";
import "./SpaServiceCard.css";
import ServiceCards from "../../MainServicePages/ServiceCards/ServiceCards";
const SpaServiceCardContain = () => {
  return (
    <div className="spaCardContainer">
      <ServiceCards
        heading="Head Massage"
        para="Pamper yourself with luxury at SCENT Salon Spa. Experience our top-notch head massage as skilled therapists whisk away your worries, leaving you refreshed and revitalized. Treat yourself today!"
        goto="Head Massage"
        img="https://img.freepik.com/free-photo/close-up-therapist-massaging-patient-s-scalp_23-2148882171.jpg?t=st=1714716388~exp=1714719988~hmac=c787c4ed81c21b2271223ae85db60e74f60d8fdb6ecb268a738e25f19dc51cbd&w=900"
        link="/head-massage-in-bangalore"
      />
      <ServiceCards
        heading="Foot Massage"
        para="Treat yourself to a calming foot massage at SCENT Salon Spa. Allow our expert therapists to release tension and re-energize your tired feet, leaving you feeling revitalized. Discover serenity today!"
        goto="Foot Massage"
        img="https://img.freepik.com/free-photo/woman-receiving-foot-massage-service-from-masseuse-close-up-hand-foot-relax-foot-massage-therapy-service-concept_1150-13728.jpg?t=st=1714716453~exp=1714720053~hmac=5d918cf6d939785d6b0fceb1ca87a750f46acfcd8e6dc47f1303bb592b2f9419&w=900"
        link="/foot-massage-in-bangalore"
      />
      <ServiceCards
        heading="Thai Reflexology"
        para="Indulge in Thai reflexology at SCENT Salon Spa. Our skilled therapists use gentle pressure techniques on your feet to promote relaxation, circulation, and balance restoration. Experience the benefits today!"
        goto="Thai Reflexology"
        img="https://img.freepik.com/free-photo/man-suction-session_23-2148824034.jpg?t=st=1714716687~exp=1714720287~hmac=b32e7f03c025748995d8ef999aa3ee8efe8bf78f0bda28651fdeb046dcd46794&w=900"
        link="/thai-reflexology-massage-in-bangalore"
      />
      <ServiceCards
        heading="Back Massage"
        para="Relax with a tranquil back massage at SCENT Salon Spa. Our expert therapists will alleviate tension and encourage relaxation in your back muscles."
        goto="Back Massage"
        img="https://img.freepik.com/free-photo/close-up-patient-getting-massage_23-2149089242.jpg?t=st=1714716561~exp=1714720161~hmac=604c72235aaeff10d0d968e66ebd04ff15a49520f7d27d7d4fa37746c16c63af&w=360"
        link="/back-massage-in-bangalore"
      />
      <ServiceCards
        heading="Aroma Massage"
        para="Experience pure relaxation with our aromatic massage at SCENT Salon Spa. Let the soothing scents of essential oils relax your mind and body while our expert therapists release tension and stress. "
        goto="Aroma Massage"
        img="https://img.freepik.com/free-photo/woman-relaxing-spa_329181-13152.jpg?t=st=1714717681~exp=1714721281~hmac=a2060ac6b7ae48b47e8b347f4f925138dfd1838986a14d1861d0a36968b5d840&w=900"
        link="/aroma-massage-in-bangalore"
      />
      <ServiceCards
        heading="Thai Massage"
        para="Experience authentic Thai massage at SCENT Salon Spa. Our skilled therapists use traditional techniques to ease tension, improve circulation, and promote overall well-being. Relax and rejuvenate today!"
        goto="Thai Massage"
        img="https://img.freepik.com/free-photo/young-couple-relaxing-back-massage-health-spa-focus-is-young-woman_637285-2209.jpg?t=st=1714717752~exp=1714721352~hmac=e2e68b5d3366ddafbd090982891ec3e3b26f49c44c9e61b25c383ed434516290&w=360"
        link="/thai-massage-in-bangalore"
      />
      <ServiceCards
        heading="Deep Tissue Massage"
        para="Indulge in ultimate relaxation with our Deep Tissue Massage at SCENT Salon Spa. Our expert therapists target deep-seated tension and muscle knots, leaving you revitalized and renewed. Treat yourself today!"
        goto="Deep Tissue Massage"
        img="https://img.freepik.com/free-photo/woman-getting-back-massage-from-female-masseur_23-2150461420.jpg?t=st=1714717833~exp=1714721433~hmac=6527598b712a7455fb6938928cc10fe6916b297ecb1f088e179d74f20521fbf4&w=360"
        link="/deep-tissue-massage-in-bangalore"
      />
      <ServiceCards
        heading="Sportz Massage"
        para="
        Revitalize with our Sportz Massage at SCENT Salon Spa. Tailored for athletes, it targets muscles to relieve tension, boost flexibility, and enhance performance. Stay at your best with this invigorating treatment!"
        goto="Sportz Massage"
        img="https://img.freepik.com/free-photo/nurse-taking-care-patient_23-2149277901.jpg?t=st=1714717924~exp=1714721524~hmac=1f574ac5df92cb19086a0ebdb2ff99d6a3101fef476c4c08b3215517f7f9e479&w=900"
        link="/sportz-massage-in-bangalore"
      />
      <ServiceCards
        heading="Balinese Massage"
        para="Experience ultimate relaxation with our Balinese Massage at SCENT Salon Spa. This ancient technique combines stretches, acupressure, and aromatherapy for muscle tension relief and tranquility."
        goto="Balinese Massage"
        img="https://img.freepik.com/free-photo/young-woman-enjoying-shoulders-massage_1098-2280.jpg?t=st=1714717990~exp=1714721590~hmac=b6ed91746b4f82b453b5b2f3f4374694fc7a6257e217759c80840f1375b51408&w=900"
        link="/balinese-massage-in-bangalore"
      />
      <ServiceCards
        heading="Scent Signature Massage"
        para="Experience bliss with our SCENT Signature Massage. This exclusive treatment combines tailored techniques for ultimate relaxation and rejuvenation. Let our skilled therapists refresh your body and mind."
        goto="Scent Signature Massage"
        img="https://img.freepik.com/free-photo/beautiful-young-woman-spa-salon_155003-3473.jpg?t=st=1714718030~exp=1714721630~hmac=2c73b51a5fdd7529d04a7ca7ef9fea91f33ded7a63d2948f11c4e7217eff06d7&w=900"
        link="/scent-signature-massage-in-bangalore"
      />
      <ServiceCards
        heading="Stone Therapy"
        para="Experience deep relaxation with our Stone Therapy at SCENT Salon Spa, where heated stones melt away stress and promote tranquility, leaving you revitalized."
        goto="Stone Therapy"
        img="https://img.freepik.com/free-photo/close-up-hands-holding-spa-stones_23-2149089222.jpg?t=st=1714718071~exp=1714721671~hmac=96496ec0aed3f6162b37a41e87c6eb60c771b4d7b91606115ac5f3cd5b61719c&w=360"
        link="/hot-stone-therapy-massage-in-bangalore"
      />
      <ServiceCards
        heading="Body Polish"
        para="Revitalize your skin with our Body Polish treatment at SCENT Salon Spa. Our gentle exfoliating scrub reveals soft, radiant skin. Treat yourself and leave feeling refreshed."
        goto="Body Polish"
        img="https://img.freepik.com/free-photo/beautiful-young-woman-with-flowers-using-scrub_186202-8347.jpg?t=st=1714718121~exp=1714721721~hmac=1f55e86f1017918a03cd62c0b9a2e97616f46a76dafe398ffe5ae0a96b2d36d1&w=826"
        link="/body-polish-in-bangalore"
      />
      <ServiceCards
        heading="Body Scrub"
        para="Indulge in silky smooth skin with our Body Scrub at SCENT Salon Spa. Our exfoliating treatment leaves your skin soft, smooth, and rejuvenated. Experience the glow today!"
        goto="Body Scrub"
        img="https://img.freepik.com/free-photo/side-view-woman-getting-massaged-spa_23-2149871261.jpg?t=st=1714718233~exp=1714721833~hmac=62f8b21d7b9888237d76705d9030c9db76fd498c3c4e48fb84d3b09e579a63d4&w=900"
        link="/body-scrub-in-bangalore"
      />
    </div>
  );
};

export default SpaServiceCardContain;
